import * as React from "react";

function SvgIcSChevronLeft(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.707 7.293a1 1 0 00-1.414 0L9 10.586a2 2 0 000 2.828l3.293 3.293a1 1 0 001.414-1.414L10.414 12l3.293-3.293a1 1 0 000-1.414z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcSChevronLeft;
